import _extends from "@babel/runtime-corejs3/helpers/extends";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _Number$isNaN from "@babel/runtime-corejs3/core-js/number/is-nan";
import { useInstance } from 'intact-vue-next';
import tinycolor from 'tinycolor2';
import { useState } from '../../hooks/useState';
export var Mode;
(function (Mode) {
  Mode[Mode["RGB"] = 0] = "RGB";
  Mode[Mode["HSL"] = 1] = "HSL";
})(Mode || (Mode = {}));
export function useInput(hsv, rgb, hsl) {
  var instance = useInstance();
  var mode = useState(Mode.RGB);
  var dragging = useState(false);
  function onInputHex(e) {
    var _context;
    var hex = _trimInstanceProperty(_context = e.target.value).call(_context);
    var color = tinycolor(hex);
    if (color.isValid()) {
      hsv.set(color.toHsv());
    }
  }
  function changeMode() {
    mode.set(mode.value === Mode.RGB ? Mode.HSL : Mode.RGB);
  }
  function changeColor(type, v) {
    var _extends2;
    var isRgb = mode.value === Mode.RGB;
    var color = isRgb ? rgb.value : hsl.value;
    if (!isRgb && type !== 'h' || type === 'a') {
      v = v / 100;
    }
    if (color[type] === v) return;
    hsv.set(tinycolor(_extends({}, color, (_extends2 = {}, _extends2[type] = v, _extends2))).toHsv());
  }
  function setInputValue(type, maxValue, e) {
    var _context2;
    var value = parseInt(_trimInstanceProperty(_context2 = e.target.value).call(_context2), 10);
    if (_Number$isNaN(value)) return;
    value = Math.min(Math.max(0, value), maxValue);
    changeColor(type, value);
  }
  function onStart() {
    dragging.set(true);
  }
  function onEnd() {
    dragging.set(false);
  }
  return {
    onInputHex: onInputHex,
    mode: mode,
    changeMode: changeMode,
    changeColor: changeColor,
    onStart: onStart,
    onEnd: onEnd,
    dragging: dragging,
    setInputValue: setInputValue
  };
}